export default __webpack_public_path__ + "static/media/ChevronRight.8f774f65.svg";